export default __webpack_public_path__ + "static/media/HUAWEI.ad816586.png";